var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path0, _circle2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeachVolley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M940.1,710.2c0,41.1-12,79.4-32.6,111.6c-36.8,57.3-101.1,95.3-174.3,95.3c-114.3,0-206.9-92.6-206.9-206.9 c0-114.3,92.6-206.9,206.9-206.9c73.2,0,137.5,38,174.3,95.3C928.1,630.8,940.1,669.1,940.1,710.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.5,598.6H689.2c-20.7,32.2-32.6,70.5-32.6,111.6c0,41.1,12,79.4,32.6,111.6h218.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M689.2,598.6c0,0-25.8-54.2-79.8-54.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.8,598.6c0,0-13.6-71.9-91.2-89.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.8,598.6c0,0-8-68.1-82.6-93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M689.2,821.6c0,0-25.8,54.2-79.8,54.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.8,822.1c0,0-13.6,71.3-91.2,89.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.8,822.1c0,0-8,67.6-82.6,92.5"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 668.5,
    y1: 665.7,
    x2: 933.3,
    y2: 665.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 658.9,
    y1: 741.4,
    x2: 933.3,
    y2: 741.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.5,857.7c0,0-55.7-58.6-56.1-143.8c-0.4-100.7,55.6-152,55.6-152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.9,874.7c0,0-68.1-54.2-68.2-164.2c-0.1-109,71.9-164.2,71.9-164.2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825,895.7c46.5,13.1,92.6,21.4,137,21.4H733.2H62c0,0,76.9-118,231.7-154.9c61.5-14.6,158.3-14.5,246,21.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3,782.3C210.6,618.7,280.5,475.5,336,388.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.3,835.1c0,0-28.2-264.5,183.8-492.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M519.3,458.5c-8.7,88.7-103,143-103,143C428,470.3,417.2,365.2,411,321c5-3,9.3-7,12.6-11.8 C456.1,332.2,526,390.3,519.3,458.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M351.2,279.7c-3.7-0.2-7.7-0.5-12.2-0.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4,279.8c-42.8,2.7-96.6,10.3-155.5,28.3c0,0,2.2-49.9,88.5-91.5c62.1-29.9,121.8,17.3,150.2,46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M609.3,390c-52.9-38.3-137.1-71-182.3-87c2.2-5,3.5-10.5,3.5-16.4c0-1.6-0.1-3.2-0.3-4.7 c35.6-9,91.1-17.1,127.8,5.5C615.7,323.1,609.3,390,609.3,390z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387.1,246.8c-6.4,0.6-12.4,2.6-17.6,5.9c-23.3-43.3-75.5-112-171-107.6c0,0,62.6-48.6,134.2-36 C381.5,117.6,387.9,197.1,387.1,246.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M594.6,187.4c-65,25.3-129.9,66.7-164.9,90.7c-2.3-10.8-9-19.9-18-25.5c8.4-27.2,25.1-59.8,58.1-75.1 C523.5,152.4,594.6,187.4,594.6,187.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 303.6,
    r: 40
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M430.6,286.6c0,5.8-1.2,11.4-3.5,16.4c-1,2.2-2.1,4.2-3.5,6.2c-3.3,4.8-7.6,8.9-12.6,11.8 c-6,3.6-13,5.6-20.5,5.6c-22.1,0-40-17.9-40-40c0-2.4,0.2-4.7,0.6-7c1.1-6.3,3.7-12.1,7.4-17c3-4,6.7-7.4,10.9-10 c5.2-3.2,11.1-5.3,17.6-5.9c1.2-0.1,2.3-0.2,3.5-0.2c7.7,0,14.9,2.2,21,6c9.1,5.6,15.7,14.8,18,25.5c0.3,1.2,0.5,2.5,0.6,3.8 C430.5,283.4,430.6,285,430.6,286.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.5,
    cy: 363.7,
    r: 40
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 799.7,
    cy: 298.2,
    r: 62.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 799.7,
    y1: 185.1,
    x2: 799.7,
    y2: 167
  }), /*#__PURE__*/React.createElement("line", {
    x1: 799.7,
    y1: 429.4,
    x2: 799.7,
    y2: 411.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 912.9,
    y1: 298.2,
    x2: 930.9,
    y2: 298.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.5,
    y1: 298.2,
    x2: 686.6,
    y2: 298.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 879.7,
    y1: 218.2,
    x2: 892.5,
    y2: 205.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 706.9,
    y1: 391,
    x2: 719.7,
    y2: 378.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 879.7,
    y1: 378.2,
    x2: 892.5,
    y2: 391
  }), /*#__PURE__*/React.createElement("line", {
    x1: 706.9,
    y1: 205.4,
    x2: 719.7,
    y2: 218.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachVolley);
export default __webpack_public_path__ + "static/media/BeachVolley.884945d78f7541662e4bc98c4de05d7c.svg";
export { ForwardRef as ReactComponent };